import React from "react";
import ArrowButton from "../common/button-arrow";

const AddStore = ({ onAddStoreClicked, registration }) => {
  return (
    <ArrowButton
      color="grey"
      className="add-button"
      arrow={false}
      submit={false}
      block={true}
      onClick={onAddStoreClicked}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        class="bi bi-plus"
        viewBox="0 0 16 16"
      >
        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
      </svg>{" "}
      Add a new store
    </ArrowButton>
  );
};

export default AddStore;



// WEBPACK FOOTER //
// ./src/components/store-summary/add-store.jsx